import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Link, Redirect } from 'react-router-dom';

import Geosuggest from 'react-geosuggest';

import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';

import './Training.css';
import { Modal, ComboBox, PublicityPicker, PhonePicker, ConfirmModal, ItemPicker, EmptyState, LoadingState, WhoToSeePicker, ShareContent } from './Common';
import { AddTeamWithSquads } from '.././pages/CreatePages/ClubInit'
import Positions from './Positions';
import data from './TrainingCategories';
import { ViewDoc } from './Documents';

export default class Training extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            activeTab: "All Training Categories",
            userTabs: ["All Training Categories", "My Training Sessions"],
            suggestions: [],
            suggested: [],
            newMaterial: []
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.getSuggestions();
        this.getSuggested();
        this.getNewContent();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getFiles = () => {
        const list = [];
        FakeData.listify(this.props.sessions).filter((item) => {
            return item.files.length > 0;
        }).forEach((item, i) => {
            FakeData.listify(item.files).forEach((_item, _i) => {
                if (!FakeData.inArray(_item, list)) {
                    list.push(_item)
                }
            })
        })

        return list;
    }

    getSuggestions = () => {
        const _that = this;
        const data = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            userTo: {
                type: this.props.userType,
                id: this.props.user.id
            },
            isYours: true
        }

        FakeData.post("/getSuggestions.php?auth0", data, {
            success(res) {
                if (!_that._isMounted) {
                    return;
                }
                _that.setState({ suggestions: res })
                setTimeout(() => {
                    _that.getSuggestions()
                }, 1000)
            },
            error(e) {
                if (!_that._isMounted) {
                    return;
                }
                setTimeout(() => {
                    _that.getSuggestions()
                }, 5000)
            }
        })
    }

    getSuggested = () => {
        const _that = this;
        const data = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            userTo: {
                type: this.props.userType,
                id: this.props.user.id
            },
            isYours: false
        }

        FakeData.post("/getSuggestions.php?auth0", data, {
            success(res) {
                if (!_that._isMounted) {
                    return;
                }
                _that.setState({ suggested: res })
                setTimeout(() => {
                    _that.getSuggested()
                }, 1000)
            },
            error(e) {
                if (!_that._isMounted) {
                    return;
                }
                setTimeout(() => {
                    _that.getSuggested()
                }, 5000)
            }
        })
    }

    getNewContent = () => {
        const _that = this;
        const data = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            userTo: {
                type: this.props.userType,
                id: this.props.user.id
            },
            array: this.getMyPages()
        }

        FakeData.post("/getNewTrainingContent.php?auth0", data, {
            success(res) {
                if (!_that._isMounted) {
                    return;
                }
                _that.setState({ newMaterial: res })
                setTimeout(() => {
                    _that.getNewContent()
                }, 1000)
            },
            error(e) {
                if (!_that._isMounted) {
                    return;
                }
                setTimeout(() => {
                    _that.getNewContent()
                }, 5000)
            }
        })
    }

    getMyPages = () => {
        const { friends, myTeams, ownTeams } = FakeData.getData("yoo");
        const list = [];
        FakeData.listify(friends).forEach((item, i) => {
            if (!FakeData.inArray(item.id + "^F", list)) {
                list.push(item.id + "^F")
            }
        })

        FakeData.listify(myTeams).forEach((item, i) => {
            if (!FakeData.inArray(item.id + "^T", list)) {
                list.push(item.id + "^T")
            }
        })

        FakeData.listify(ownTeams).forEach((item, i) => {
            if (!FakeData.inArray(item.id + "^T", list)) {
                list.push(item.id + "^T")
            }
        })

        return list;
    }

    render = () => {
        const { sessions, files } = this.props;
        const { suggestions, newMaterial, suggested } = this.state;
        if (!this.props.user.isAdmin) {
            <Redirect to={{
                pathname: FakeData.getPath(this.props.user),
                state: { from: { pathname: "/404" } }
            }} />
        }
        return (
            <div className={this.props.userType==="F"?"default-view sp-flex-width":"default-view"} style={{ backgroundColor: "#fff",  paddingBottom: "20px", width:this.props.userType==="F"?"":"100%", marginTop:"10px" }}>
                <div className="view-with-tabs">
                    <div className="view-with-tabs-head">
                        {
                            this.state.userTabs.map((item, i) => {
                                return (
                                    <div key={i} className={(item === this.state.activeTab) ? "view-with-tabs-head-item active" : "view-with-tabs-head-item"} onClick={() => this.setState({ activeTab: item })}>{item}</div>
                                )
                            })
                        }
                    </div>
                    <div className="view-with-tabs-body">
                        {this.state.activeTab === "All Training Categories" &&
                            <TRCategories isAddingToSession={false} suggestions={suggested} newMaterial={newMaterial} sessions={sessions} files={this.getFiles()} toId={this.props.user.id} toType={this.props.userType} />
                        }
                        {this.state.activeTab === "My Training Sessions" &&
                            <TRSessions suggestions={suggestions} newMaterial={newMaterial} sessions={sessions} files={files} toId={this.props.user.id} toType={this.props.userType} />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export class TRSessions extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            typeFilter: "My sessions",
            typeFilterKeySession: "All",
            isAdding: false,
            isEditting: false,
            currentSession: { id: null, files: [], type: "" },
            isAddingDoc: false,
            isAddingSuggested: false,
            isCreatingSession: false,
            isManaging: false,
            docType: null,
            isSharing: false
        }
    }

    shareSession = () => {
        this.setState({ isSharing: true });
    }

    deleteSettion = () => {

    }

    getFilteredSessions = (type) => {
        const { sessions, files, suggestions, newMaterial } = this.props;
        if (type === "Favoured sessions") {
            const list = [];
            if (list.length > 0) {
                //this.setState({currentSession:list[0]});
            } else {
                //this.setState({currentSession: { id: null, files: [] }});
            }

            return list;
        } else if (type === "Suggested sessions") {
            const list = [];
            FakeData.listify(suggestions).forEach((item, i) => {
                if (item.type === "session") {
                    item.content.suggestedBy = item.from;
                    item.content.type = "Suggested";
                    list.push(item.content);
                }
            })

            return list;
        } else {
            const _type = type === "My sessions" ? "You" : type === "Team sessions" ? "Team" : type === "Group sessions" ? "Group" : "Friend";
            const list = FakeData.listify(sessions).filter((item, i) => {
                return item.type === _type;
            });

            if (list.length > 0 && this.state.currentSession === null) {
                //this.setState({currentSession:list[0]});
            } else {
                //this.setState({currentSession: { id: null, files: [] }});
            }

            return list;
        }
    }

    render = () => {
        const { typeFilter, typeFilterKeySession, docType, isAdding, isAddingDoc, isCreatingSession, isEditting, currentSession, isAddingSuggested, isManaging } = this.state
        const { sessions, files, suggestions, newMaterial, toType } = this.props
        return (
            <div className="training">
                <div data-header="">
                    <div data-tabs="">
                        <span className={(typeFilter === "My sessions") ? "active" : ""} onClick={() => this.setState({ typeFilter: "My sessions" })}>My sessions</span>
                        {toType === "F" && <span className={(typeFilter === "Team sessions") ? "active" : ""} onClick={() => this.setState({ typeFilter: "Team sessions" })}>Team sessions</span>}
                        {(toType === "F" || toType === "C" || toType === "I") && <span className={(typeFilter === "Friends sessions") ? "active" : ""} onClick={() => this.setState({ typeFilter: "Friends sessions" })}>Friends sessions</span>}
                        <span className={(typeFilter === "Favoured sessions") ? "active" : ""} onClick={() => this.setState({ typeFilter: "Favoured sessions" })}>Favoured sessions</span>
                        <span className={(typeFilter === "Suggested sessions") ? "active" : ""} onClick={() => this.setState({ typeFilter: "Suggested sessions" })}>Suggested sessions</span>
                    </div>
                    <div data-buttons>
                        <div data-button>
                            <span>Create a new training session</span>
                            <div>
                                <a className="add" onClick={() => this.setState({ isCreatingSession: (isCreatingSession) ? false : true })}></a>
                            </div>
                        </div>
                    </div>
                </div>
                {isCreatingSession &&
                    <AddSession {...this.props} />
                }
                <div data-content="">
                    <div data-side="">
                        <div data-side-tabs>
                            {
                                this.getFilteredSessions(typeFilter).map((item, i) => {
                                    return (
                                        <div key={item.id} className={(currentSession.id === item.id) ? "selected" : ""} onClick={() => this.setState({ currentSession: item })}>{item.name}</div>
                                    )
                                })
                            }
                        </div>
                        {(this.getFilteredSessions().length - 10 > 0) &&
                            <div className="session-filter-ctrl">
                                <div data-if="currentSessionOffset>0">Prev</div>
                                <div data-if="currentSessionLimit<=currentSessions.length">Next</div>
                            </div>
                        }
                    </div>
                    <div data-main="" className="my-sessions">
                        {(currentSession !== null && isEditting) &&
                            <h2 style={{ margin: 0, fontSize: "22px", lineHeight: "22px", padding: "10px 0px 0px 10px" }}>{currentSession.name}</h2>
                        }
                        <div data-header="">
                            <div data-tabs="">
                                <span className={(typeFilterKeySession === "All") ? "active" : ""} onClick={() => this.setState({ typeFilterKeySession: "All" })}>All</span>
                                <span className={(typeFilterKeySession === "Videos") ? "active" : ""} onClick={() => this.setState({ typeFilterKeySession: "Videos" })}>Videos</span>
                                <span className={(typeFilterKeySession === "Images") ? "active" : ""} onClick={() => this.setState({ typeFilterKeySession: "Images" })}>Images</span>
                                <span className={(typeFilterKeySession === "Documents") ? "active" : ""} onClick={() => this.setState({ typeFilterKeySession: "Documents" })}>Documents</span>
                            </div>
                            <div data-buttons>
                                {typeFilter === "My sessions" &&
                                    <div data-button>
                                        <span>Add</span>
                                        <div>
                                            <a className="add" onClick={() => this.setState({ isAdding: (isAdding) ? false : true })}></a>
                                            {isAdding &&
                                                <a onClick={() => this.setState({ isAddingDoc: true, docType: "docement" })} style={{ backgroundImage: "url(images/document_icon_drk.svg)", opacity: "0.5", marginRight: "-10px" }}></a>
                                            }
                                            {isAdding &&
                                                <a onClick={() => this.setState({ isAddingDoc: true, docType: "media" })} style={{ backgroundImage: "url(images/add_photo_icon_drk.svg)", opacity: "0.5" }}></a>
                                            }
                                        </div>
                                    </div>
                                }
                                {typeFilter === "Suggested sessions" &&
                                    <div data-button>
                                        <span>Add</span>
                                        <div>
                                            <a className="add" onClick={() => this.setState({ isAddingSuggested: (isAddingSuggested) ? false : true })}></a>
                                        </div>
                                    </div>
                                }
                                {typeFilter === "My sessions" &&
                                    <div data-button>
                                        <span>Edit</span>
                                        <div>
                                            <a className="add" onClick={() => this.setState({ isManaging: (isManaging) ? false : true })}></a>
                                            {(isManaging && !isEditting) &&
                                                <a onClick={() => this.setState({ isEditting: true })} style={{ backgroundImage: "url(images/edit.png)", opacity: "0.5", marginRight: "-10px", marginTop: "5px", backgroundSize: "25px 25px" }}></a>
                                            }
                                            {(isManaging && !isEditting) &&
                                                <a onClick={this.deleteSettion.bind(this)} style={{ backgroundImage: "url(images/delete.svg)", opacity: "0.5" }}></a>
                                            }
                                        </div>
                                    </div>
                                }
                                {(typeFilter === "My sessions" && currentSession.type === "You") &&
                                    <div data-button>
                                        <span></span>
                                        <div>
                                            <a className="share" onClick={this.shareSession.bind(this)}></a>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div data-content="">
                            {
                                currentSession.files.map((item, i) => {
                                    if (typeFilterKeySession !== "All" && typeFilterKeySession === "Documents" && item.type !== "document") {
                                        return null;
                                    } else if (typeFilterKeySession !== "All" && typeFilterKeySession === "Images" && item.type !== "image") {
                                        return null;
                                    } else if (typeFilterKeySession !== "All" && typeFilterKeySession === "Videos" && item.type !== "video") {
                                        return null;
                                    }
                                    return (
                                        <SessionFile canFav={false} isEditting={isEditting} isAddingToSession={false} className="session-file" key={i} file={item} userType={this.props.toType} user={{ id: this.props.toId, type: this.props.toType }} />
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                {(docType !== null && isAddingDoc) &&
                    <AddDocument toId={this.props.toId} toType={this.props.toType} sessions={sessions} files={files} isOpen={isAddingDoc} isMedia={docType === "media" ? true : false} onClose={(args) => {
                        this.setState({ isAddingDoc: false, docType: null });
                    }} />
                }
                {(currentSession.files.length > 0 && this.state.isSharing) &&
                    <ShareContent hideSportLabel={true} style={null} post={currentSession} type={"SESSION"} user={this.props.user} userType={this.props.userType} isOpen={this.state.isSharing} onClose={() => {
                        this.setState({ isSharing: false })
                    }}>
                        <EmbedMaterial isFile={false} session={currentSession} />
                    </ShareContent>
                }
            </div>
        );
    }
}

class SessionFile extends Component {
    state = {
        isSharing: false,
        isSelected: false,
        isViewing: false
    }

    like() {
        const dataTo = {
            user: this.props.user,
            type: "session-file",
            contentId: this.props.file.id,
            userOne: this.props.file.user,
            userTwo: null,
            users: [],
            userType: this.props.userType
        }
        const _that = this

        FakeData.post('/likeContent.php?auth0', dataTo, {
            success: ((res) => {
                FakeData.alert("Done!");
            }),
            error: ((err) => {

            })
        }, true, "", () => { })
    }

    shareNow = () => {
        this.refs.share.blur()
        const _that = this;
        const data = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            userTo: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            content: "",
            coord: { lat: 0, lng: 0 },
            audience: "friends",
            type: "FILE",
            post: this.props.file,
            postType: "normal",
            place: { name: "" },
            tagged: []
        }

        FakeData.post("/sharePost.php?auth0", data, {
            success(res) {
                FakeData.alert("Post shared on your timeline!");
            },
            error(err) {

            }
        }, true, "", () => { })
    }

    getDocumentIcon = (type) => {
        let str = "";
        switch (type) {
            case "pdf":
                str = "";
                break;
            case "xls":
                str = "";
                break;
            case "doc":
                str = "doc_icon_training.svg";
                break;
            case "ppt":
                str = "";
                break;
            default:
                break;
        }
        return "";
    }

    fav = () => {
        const _that = this;
        const { file } = this.props;
        const _data = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            file
        }

        FakeData.post("/addToFavoured.php?auth0", _data, {
            success(e) {
                if (e.status) {
                    FakeData.alert("Done!")
                } else {

                }
            },
            error(e) { }
        }, true, "", () => { })
    }

    render = () => {
        const { file, isAddingToSession, isEditting, canFav } = this.props;
        const { isSharing, isSelected, isViewing } = this.state;
        return (
            <div className="session-file">
                <div className="session-file-ctx">
                    <div className={"session-file-actions"}>
                        {!isAddingToSession && isEditting && !canFav && <div className="session-file-actions-delete" />}
                        {isAddingToSession && !isEditting && !canFav &&
                            <div className="session-file-actions-add-to">
                                <i className={"material-icons"}>{isSelected ? "check_box" : "check_box_outline_blank"}</i><span>Add</span>
                            </div>
                        }
                        {!isAddingToSession && !isEditting && canFav &&
                            <div className="session-file-actions-favor" onClick={this.fav.bind(this)}>
                                <img src={file.isFavoured ? (file.type === "image" ? "images/star_blu.svg" : file.type === "video" ? "images/star_yel.svg" : "images/star_grn.svg") : "images/star_wht.svg"} />
                            </div>
                        }
                    </div>
                    <div className="session-file-image" onClick={()=>{
                        if(file.type==="document"){
                            this.setState({ isViewing: true });
                        }
                    }}>
                        {file.type === "document" &&
                            <img src={"/images/" + file.file.type + "_icon_training.svg"} />
                        }
                        {file.type === "image" &&
                            <img src={file.file.url} />
                        }
                        {(file.type === "video" && !file.isLink) &&
                            <video width={"100%"} height={"100%"} controls={true} src={file.file.url} />
                        }
                        {file.isLink &&
                            <EmbedVideo src={file.file.link} width={"100%"} height={"100%"} type={file.file.source} id={file.file.id} />
                        }
                    </div>
                    <div className="session-file-content">
                        <div className="session-file-content-title">{file.title}</div>
                        <span>By <a>{file.user.name}</a></span>
                        <div className="session-file-content-description">{FakeData.nullify(file.description).substring(0, 50) + (FakeData.nullify(file.description).length > 50 ? "..." : "")}</div>
                        <div className="post-actions session-file-content-actions">
                            <div className="post-action like" onClick={() => this.like()}><i className="material-icons">thumb_up</i><span className="action-label">{FakeData.shortDigit(file.likes.length, "Like").data}</span></div>
                            <div className="post-action comment" onClick={() => { }}><i className="material-icons">chat_bubble</i><span className="action-label">{FakeData.shortDigit(file.comments.length, "Comment").data}</span></div>
                            <div className="post-action share share-ctx" ref={"share"} tabIndex={0} onClick={() => {
                                this.setState({ isSharing: true })
                                this.refs.share.blur()
                            }}>
                                <i className="material-icons" style={{ transform: "rotateY(-180deg)" }}>reply</i>
                                <span className="action-label">{FakeData.shortDigit(file.shares.length, "Share").data}</span>
                            </div>
                        </div>
                    </div>
                </div>
                {isSharing &&
                    <ShareContent hideSportLabel={true} style={null} post={file} type={"SESSIONFILE"} user={this.props.user} userType={this.props.userType} isOpen={isSharing} onClose={() => {
                        this.setState({ isSharing: false })
                    }}>
                        <EmbedMaterial isFile={true} file={file} />
                    </ShareContent>
                }
                {isViewing &&
                    <ViewDoc doc={file} noRead={true} isOpen={isViewing} onClose={(args) => {
                        this.setState({ isViewing: false });
                    }} />
                }
            </div>
        )
    }
}

export class EmbedMaterial extends React.PureComponent {
    state = {}
    render = () => {
        const { file, isFile, session } = this.props;
        if (!isFile) {
            if (FakeData.listify(session.files).length === 0) {
                return null;
            }

            let _file = FakeData.listify(session.files)[0];

            return (
                <div className="embed-material" style={{ width: "100%", height: "5vw" }}>
                    <div className="embed-material-image">
                        {_file.type === "document" &&
                            <img src={"/images/" + _file.file.type + "_icon_training.svg"} />
                        }
                        {_file.type === "image" &&
                            <img src={_file.file.url} />
                        }
                        {(_file.type === "video" && !_file.isLink) &&
                            <video width={"100%"} height={"100%"} controls={true} src={_file.file.url} />
                        }
                        {_file.isLink &&
                            <EmbedVideo src={_file.file.link} width={"100%"} height={"100%"} type={_file.file.source} id={_file.file.id} />
                        }
                    </div>
                    <div className="embed-material-ctx">
                        <h1>{session.name !== "" ? session.name : "Unnamed Session"}</h1>
                        <span>By <a>{session.user.name}</a></span>
                    </div>
                </div>
            )
        }
        return (
            <div className="embed-material" style={{ width: "100%", height: "5vw" }}>
                <div className="embed-material-image">
                    {file.type === "document" &&
                        <img src={"/images/" + file.file.type + "_icon_training.svg"} />
                    }
                    {file.type === "image" &&
                        <img src={file.file.url} />
                    }
                    {(file.type === "video" && !file.isLink) &&
                        <video width={"100%"} height={"100%"} controls={true} src={file.file.url} />
                    }
                    {file.isLink &&
                        <EmbedVideo src={file.file.link} width={"100%"} height={"100%"} type={file.file.source} id={file.file.id} />
                    }
                </div>
                <div className="embed-material-ctx">
                    <h1>{file.title !== "" ? file.title : "Unnamed File"}</h1>
                    <span>{file.description !== "" ? FakeData.nullify(file.description).substr(0, 100) + (FakeData.nullify(file.description).length > 100 ? "..." : "") : "No description"}</span>
                    <span>By <a>{file.user.name}</a></span>
                </div>
            </div>
        )
    }
}

export class EmbedVideo extends React.PureComponent {
    state = {}
    render = () => {
        const { type, width, height, style, src, id } = this.props;
        if (type === "dailymotion") {
            return (
                <iframe frameBorder="0" width={width} height={height} src={"//www.dailymotion.com/embed/video/" + id} allowFullScreen={true}></iframe>
            )
        } else if (type === "vimeo") {
            return (
                <iframe src={"https://player.vimeo.com/video/" + id + "?transparent=0"} width={width} height={height} frameBorder="0" allowFullScreen={true}></iframe>
            )
        } else if (type === "youtube") {
            return (
                <iframe src={"https://www.youtube.com/embed/" + id} width={width} height={height} frameBorder="0" allowFullScreen={true}></iframe>
            )
        } else if (type === "vine") {
            return (
                <iframe src={"https://vine.co/v/" + id + "/embed/simple"} width={width} height={height} frameBorder="0" allowFullScreen={true}></iframe>
            )
        } else {
            return null;
        }
    }
}

export class TRCategories extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            typeFilter: "All",
            isAdding: false,
            isAddingDoc: false,
            isShowingSuggestions: false,
            docType: null,
            sport: "",
            filter: "",
            string: ""
        }
    }

    showSuggestions = () => {

    }

    getNewNotices = (list) => {
        const _list = []

        return _list;
    }

    render = () => {
        const { typeFilter, isAdding, isAddingDoc, isShowingSuggestions, docType, sport, filter, string } = this.state;
        const { sessions, files, suggestions, newMaterial } = this.props;
        const noticeCount = FakeData.listify(suggestions).filter((item) => { return item.type === "material" }).length + FakeData.listify(newMaterial).length;
        return (
            <div className="training">
                <div data-header="">
                    <div data-tabs="">
                        <span className={(typeFilter === "All") ? "active" : ""} onClick={() => this.setState({ typeFilter: "All" })}>All</span>
                        <span className={(typeFilter === "Videos") ? "active" : ""} onClick={() => this.setState({ typeFilter: "Videos" })}>Videos</span>
                        <span className={(typeFilter === "Images") ? "active" : ""} onClick={() => this.setState({ typeFilter: "Images" })}>Images</span>
                        <span className={(typeFilter === "Documents") ? "active" : ""} onClick={() => this.setState({ typeFilter: "Documents" })}>Documents</span>
                    </div>
                    <div data-filters="">
                        <select className="select-box" value={sport === "" ? "Select a sport" : sport} onChange={(e) => {
                            this.setState({ sport: e.target.value });
                        }} style={{ lineHeight: "30px" }}>
                            <option value="Select a sport">Select a sport</option>
                            {
                                FakeData.listify(FakeData.getData("yoo").mySport || FakeData.getData("yoo").sportsFollowed).map((item, i) => {
                                    return (
                                        <option key={i} value={item.name}>{item.name}</option>
                                    )
                                })
                            }
                        </select>
                        <select className="select-box" value={filter === "" ? "Filter by" : filter} onChange={(e) => {
                            this.setState({ filter: e.target.value });
                        }} style={{ lineHeight: "30px" }}>
                            <option value="Latest">Latest</option>
                            <option value="Viewed">Most viewed</option>
                            <option value="Commented">Most commented</option>
                            <option value="Liked">Most liked</option>
                        </select>
                        <input value={string} className="select-box" style={{ padding: "4px", marginTop: "-3px" }} placeholder="Type Team, Coach or Group" onChange={(e) => {
                            this.setState({ string: e.target.value });
                        }} />
                    </div>
                    <div data-buttons>
                        <div data-button>
                            <span>Add</span>
                            <div>
                                <a className="add" onClick={() => this.setState({ isAdding: (isAdding) ? false : true })}></a>
                                {isAdding &&
                                    <a onClick={() => this.setState({ isAddingDoc: true, docType: "docement" })} style={{ backgroundImage: "url(images/document_icon_drk.svg)", opacity: "0.5", marginRight: "-10px" }}></a>
                                }
                                {isAdding &&
                                    <a onClick={() => this.setState({ isAddingDoc: true, docType: "media" })} style={{ backgroundImage: "url(images/add_photo_icon_drk.svg)", opacity: "0.5" }}></a>
                                }
                            </div>
                        </div>
                        <div data-button>
                            <span></span>
                            <div>
                                <a className="alert" onClick={() => this.setState({ isShowingSuggestions: true })} data-notices={noticeCount}></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div data-content="">
                    <div data-side="">
                        <div className="category_selector">Select categories</div>
                        <div className="training-tags">
                        </div>
                        <div className="categories_select_btn" style={{ zIndex: 0 }}>Filter material</div>
                    </div>
                    <div data-main="">
                        {
                            files.map((item, i) => {
                                if (typeFilter !== "All" && typeFilter === "Documents" && item.type !== "document") {
                                    return null;
                                } else if (typeFilter !== "All" && typeFilter === "Images" && item.type !== "image") {
                                    return null;
                                } else if (typeFilter !== "All" && typeFilter === "Videos" && item.type !== "video") {
                                    return null;
                                }

                                return (
                                    <SessionFile canFav={!this.props.isAddingToSession} isEditting={false} isAddingToSession={this.props.isAddingToSession} className="session-file" key={i} file={item} userType={this.props.toType} user={{ id: this.props.toId, type: this.props.toType }} />
                                )
                            })
                        }
                    </div>
                </div>
                {(docType !== null && isAddingDoc) &&
                    <AddDocument toId={this.props.toId} toType={this.props.toType} isOpen={isAddingDoc} sessions={sessions} files={files} isMedia={docType === "media" ? true : false} onClose={(args) => {
                        this.setState({ isAddingDoc: false, docType: null });
                    }} />
                }
                {isShowingSuggestions &&
                    <TRNoticeModal toId={this.props.toId} toType={this.props.toType} sessions={FakeData.listify(sessions).filter((item) => { return item.type === "You" })} suggestions={suggestions} newMaterial={newMaterial} isOpen={isShowingSuggestions} onClose={() => {
                        this.setState({ isShowingSuggestions: false });
                    }} />
                }
            </div>
        );
    }
}

export class AddDocument extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sport: { id: null, name: null },
            doc: {
                id: null,
                user: FakeData.getData("yoo"),
                commentType: "file",
                title: "",
                description: "",
                link: "",
                sport: { id: null, name: "" },
                sportToSee: [],
                teamToSee: [],
                tags: [],
                type: "file",
                isFile: true,
                comments: [],
                likes: [],
                isReadable: false,
                shares: [],
                session: { id: null, name: "" },
                file: { id: null, name: "" }
            },
            linkWarning: "Only enter video url from youtube, vimoe, dailymotion and vine",
            source: {
                from: "",
                like: ""
            },
            errors: {
                link: false,
                title: false,
                description: false,
                file: false,
                sport: false,
                tag: false,
                session: false,
                sportToSee: false,
                teamToSee: false
            },
            session: ""
        }

        this.onFilesPicked = this.onFilesPicked.bind(this);
    }

    onClose = (args) => {
        this.props.onClose(args)
    }

    onUrlFieldChange = (e) => {
        const { sport, doc, errors, source } = this.state
        const val = e.target.value;
        doc.link = val
        this.setState({
            source: this.checkLinkSource(val),
            doc
        });
    }

    checkLinkSource = (val) => {
        var obj = {
            from: "",
            like: ""
        };

        if ((val.indexOf('youtube') != -1)) {
            obj = {
                from: "YouTube",
                like: "https://youtube.com/watch?v=wvZ6nB3cl1w"
            };
        } else if ((val.indexOf('vimeo') != -1)) {
            obj = {
                from: "Vimeo",
                like: "https://vimeo.com/212692070"
            };
        } else if ((val.indexOf('dailymotion') != -1)) {
            obj = {
                from: "Dailymotion",
                like: "http://www.dailymotion.com/video/xwr14q"
            };
        } else if ((val.indexOf('vine') != -1)) {
            obj = {
                from: "Vine",
                like: "https://vine.co/v/Ml16lZVTTxe"
            };
        } else {
            obj = {
                from: "",
                like: ""
            };
        }

        return obj;
    }

    setTags = (tag) => {
        const { sport, doc, errors, source } = this.state
        if (!FakeData.inArray(tag, doc.tags)) {
            doc.tags.push(tag)
            errors.tag = false
            this.setState({ doc, errors });
        } else {
            const _index = doc.tags.indexOf(tag);
            doc.tags.splice(_index, 1)
            errors.tag = doc.tags.length < 1 ? true : false
            this.setState({ doc, errors });
        }
    }

    addSession = (e) => {
        const { session } = this.state;
        const _that = this;
        if (e.keyCode === 13 || e.which === 13) {
            const dataTo = {
                user: {
                    id: this.props.toId,
                    type: this.props.toType
                },
                name: session,
                timeAgo: new Date(),
                files: [],
                description: ""
            }

            //console.log(dataTo)
            FakeData.post('/createSession.php?auth0', dataTo, {
                success(res) {
                    _that.setState({ session: "" });
                },
                error(err) {

                }
            }, true, "", () => { })
        }
    }

    onFilesPicked = (files) => {
        const _that = this
        const { doc } = this.state;
        const file = files[0]
        let reader = new FileReader()
        reader.onloadend = () => {
            const newFile = {
                file: file,
                progress: 0,
                url: reader.result
            }

            doc.file = newFile;

            _that.setState({
                doc
            });

            this.uploadFile(newFile)
        }
        reader.readAsDataURL(file)
    }

    uploadFile = (file) => {
        var formdata = new FormData();
        const _that = this;
        const { toId, toType } = this.props
        formdata.append("file", file.file);
        formdata.append("location", "");
        formdata.append("albumId", 0);
        formdata.append("tags", "");
        formdata.append("toId", this.props.toId);
        var ajax = new XMLHttpRequest();
        ajax.upload.addEventListener("progress", (e) => {
            let percent = Math.round((e.loaded / e.total) * 100);
            _that.state.doc.file.progress = percent;
            _that.state.errors.file = (percent < 95) ? true : false;
            _that.setState({
                doc: _that.state.doc,
                errors: _that.state.errors
            });
        }, false);
        ajax.addEventListener("load", (e) => {
            let data = JSON.parse(e.target.responseText)
            data.oldUrl = file.url
            _that.state.doc.file = data;
            _that.state.errors.file = false;
            _that.setState({
                doc: _that.state.doc,
                errors: _that.state.errors
            });
        }, false);
        ajax.open("POST", FakeData.URL + "/uploadMedia.php?auth0&userType=F&userId=" + FakeData.getData("yoo").id + "&type=" + this.props.toType);
        ajax.send(formdata);
    }

    save = () => {
        const { sport, doc, errors, source } = this.state
        const { sessions, files, isMedia } = this.props
        if (doc.title === null || doc.title === "") {
            errors.title = true;
            this.setState({ errors });
            return;
        }

        if (doc.isFile && doc.file.id === null) {
            errors.file = true;
            this.setState({ errors });
            return;
        }

        if (!doc.isFile && (doc.link === null || doc.link === "")) {
            errors.link = true;
            this.setState({ errors });
            return;
        }

        if (doc.sport.id === null) {
            errors.sport = true;
            this.setState({ errors });
            return;
        }

        if (doc.description === null || doc.description === "") {
            errors.description = true;
            this.setState({ errors });
            return;
        }

        if (doc.tags.length === 0) {
            errors.tag = true;
            this.setState({ errors });
            return;
        }

        if (doc.sportToSee.length === 0) {
            errors.sportToSee = true;
            this.setState({ errors });
            return;
        }

        if (doc.teamToSee.length === 0) {
            errors.sportToSee = true;
            this.setState({ errors });
            return;
        }

        if (doc.session.id === null) {
            errors.session = true;
            this.setState({ errors });
            return;
        }

        const _that = this;

        FakeData.post("/createSessionFile.php?auth0", doc, {
            success(e) {
                _that.onClose(e)
            },
            error(e) {
                FakeData.alert("Could'nt save file!");
            }
        }, true, "", (e) => { })
    }

    render = () => {
        const { sport, doc, errors, source } = this.state
        const { sessions, files } = this.props
        return (
            <Modal isOpen={this.props.isOpen} onClose={this.onClose}>
                <div className="add-place" style={{ width: "50vw", minHeight: "80vh" }}>
                    <h1>Document Upload</h1>
                    <div className="split-input">
                        <div>
                            <div className="input-field" style={{ height: "auto", marginBottom: "5px" }}>
                                <span>Document title</span>
                                <input className={errors.title ? "normal-input error" : "normal-input"} onChange={(e) => {
                                    const va = e.target.value;
                                    doc.title = va;
                                    errors.title = false;
                                    this.setState({ doc, errors });
                                }} />
                            </div>
                            {this.props.isMedia &&
                                <div style={{ lineHeight: "30px" }} onClick={() => {
                                    doc.isFile = (doc.isFile) ? false : true
                                    this.setState({ doc });
                                }}>
                                    <input id="isReadable" checked={(doc.isFile) ? false : true} name="checkbox" type="checkbox" /> <label>Add by link?</label>
                                </div>
                            }
                            {(!this.props.isMedia || doc.isFile) &&
                                <div className="input-field" style={{ height: "auto", marginBottom: "5px" }}>
                                    <span>Upload document</span>
                                    <input type={"file"} accept={this.props.isMedia ? "image/*,video/*" : "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpointtd>,application/vnd.openxmlformats-officedocument.presentationml.presentation"} onChange={(e) => this.onFilesPicked(e.target.files)} className={errors.file ? "normal-input error" : "normal-input"} />
                                </div>
                            }
                            {!doc.isFile &&
                                <div className="input-field" style={{ height: "auto", marginBottom: "5px" }}>
                                    <span>Only enter <code>video url</code> from <code>youtube</code>, <code>vimeo</code>, <code>dailymotion</code> and <code>vine</code></span>
                                    <input className={(source.from === "" || errors.link) ? "normal-input error" : "normal-input"} onChange={this.onUrlFieldChange.bind(this)} />
                                </div>
                            }
                            {(!doc.isFile && source.from !== "") &&
                                <span style={{ fontSize: "11px", display: "block", borderLeft: "2px solid #333", padding: "5px", background: "#f3f6fb" }}>A link from {source.from} should look like <code>{source.like}</code></span>
                            }
                            <div className="input-field" style={{ height: "auto", marginBottom: "0px" }}>
                                <span>Select a sport</span>
                                <ComboBox holderCss={null} error={errors.sport} boxCss={{ marginRight: "0px" }} btnCss={{ height: "27px" }} placeholder={""} onSelectedItem={(item) => {
                                    doc.sport = item
                                    doc.tags = []
                                    errors.sport = false
                                    this.setState({ sport: item, doc, errors });
                                }} data={FakeData.listify(FakeData.getData("yoo").sportsFollowed)} />
                            </div>
                        </div>
                        <div>
                            <div className="input-field" style={{ height: "100%" }}>
                                <span>Document description</span>
                                <textarea style={{ height: "100%", resize: "none" }} className={errors.description ? "error" : ""} onChange={(e) => {
                                    const va = e.target.value;
                                    doc.description = va;
                                    errors.description = false;
                                    this.setState({ doc, errors });
                                }} />
                            </div>
                        </div>
                    </div>
                    <h4>Categories</h4>
                    <div className={errors.tag ? "cat-tags error" : "cat-tags"}>
                        {
                            FakeData.listify(data[sport.name]).map((item, i) => {
                                return (
                                    <div className="cat-tag" key={i}>
                                        {(!item.value) &&
                                            <div className="cat-item" onClick={() => this.setTags(item.name)}>
                                                <input checked={FakeData.inArray(item.name, doc.tags) ? true : false} id={item.name + i} name="checkbox" type="checkbox" /> <label>{item.name}</label>
                                            </div>
                                        }
                                        {(item.value) &&
                                            <CategorieItem item={item} selection={doc.tags} onSelectedItem={this.setTags.bind(this)} />
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                    <h4>Who should see this?</h4>
                    Select from one/or all of the options below. <em><strong>All</strong></em> means friends, team mates and cometition can see these.
                    <div className="triple-split">
                        <div className="input-field" style={{ height: "auto", marginBottom: "0px", maxWidth: "33%" }}>
                            <span>Select sport to see</span>
                            <ComboBox multiple={true} holderCss={null} error={errors.sportToSee} boxCss={{ marginRight: "0px" }} btnCss={{ height: "27px" }} placeholder={""} onSelectedItem={(item) => {
                                doc.sportToSee = item
                                errors.sportToSee = false
                                this.setState({ doc, errors });
                            }} data={FakeData.listify(FakeData.getData("yoo").sportsFollowed)} />
                        </div>
                        <div className="input-field" style={{ height: "auto", marginBottom: "0px", maxWidth: "33%" }}>
                            <span>Select teams to see</span>
                            <ComboBox multiple={true} holderCss={null} boxCss={{ marginRight: "0px" }} btnCss={{ height: "27px" }} placeholder={""} onSelectedItem={(item) => {
                                doc.teamToSee = item
                                errors.teamToSee = false
                                this.setState({ doc, errors });
                            }} data={FakeData.listify(FakeData.getData("yoo").myTeams) || FakeData.listify(FakeData.getData("yoo").teamsFollowed)} />
                        </div>
                        <div className="input-field" style={{ height: "auto", marginBottom: "0px", maxWidth: "33%" }}>
                            <span>Select friends to see</span>
                            <ComboBox multiple={true} holderCss={null} boxCss={{ marginRight: "0px" }} btnCss={{ height: "27px" }} placeholder={""} onSelectedItem={(item) => {
                                doc.friendsToSee = item
                                errors.friendsToSee = false
                                this.setState({ doc, errors });
                            }} data={FakeData.listify(FakeData.getData("yoo").friends)} />
                        </div>
                    </div>
                    <h4>Training Sessions</h4>
                    Select a training session to associate your document with.
                    <div className="split-input" style={{ marginTop: "5px" }}>
                        <div className="input-field" style={{ height: "auto", marginBottom: "0px" }}>
                            <span>Select a session</span>
                            <ComboBox holderCss={null} error={errors.session} boxCss={{ marginRight: "0px" }} btnCss={{ height: "27px" }} placeholder={""} onSelectedItem={(item) => {
                                doc.session = item;
                                errors.session = false;
                                this.setState({ doc, errors });
                            }} data={FakeData.listify(sessions)} />
                        </div>
                        <div className="input-field" style={{ height: "auto", marginBottom: "5px" }}>
                            <span>Create a new session </span>
                            <input className="normal-input" value={this.state.session} onChange={(e) => {
                                this.setState({ session: e.target.value });
                            }} onKeyPress={(e) => {
                                if ((e.keyCode === 13 || e.which === 13)) {
                                    e.preventDefault()
                                }
                            }} onKeyUp={this.addSession.bind(this)} />
                        </div>
                    </div>
                    <div style={{ lineHeight: "30px" }} onClick={() => {
                        doc.isReadable = doc.isReadable ? false : true
                        this.setState({ doc });
                    }}>
                        <input id="isReadable" checked={doc.isReadable ? false : true} readOnly name="checkbox" type="checkbox" /> <label>Allow downloads?</label>
                    </div>
                    <button onClick={this.save.bind(this)}>Submit Document</button>
                </div>
            </Modal>
        )
    }

}

export class AddSession extends Component {
    state = {
        isTaggingAudience: false,
        audienceKey: "F",
        tags: []
    }

    openTag = (key) => {
        this.setState({
            isTaggingAudience: true,
            audienceKey: key
        });
    }

    onClose = (arr) => {
        this.setState({
            isTaggingAudience: false,
            tags: arr
        });
    }

    render = () => {
        const { sessions, files, suggestions, newMaterial, toType, toId } = this.props
        return (
            <div data-stepper="" className="add-session-block">
                <AddSessionField header={"STEP 1"} subHeader={"CREATE SESSION"} bigImg={"images/document_icon_drk.svg"} smallImg={"images/add_circle_wht.svg"}>
                    <div className="add-session-block-body-ctx">
                        <div className="add-session-block-body-ctx-holder">
                            <ul>
                                <li>Click <i>Create/Manage</i> Session below to add a session.</li>
                                <li>Select your session from the drop down list below.</li>
                            </ul>
                        </div>
                        <input style={{ padding: "0px 4px", lineBreak: "30px" }} placeholder="Write..." />
                    </div>
                </AddSessionField>
                <AddSessionField header={"STEP 2"} subHeader={"ADD MATERIAL"} bigImg={"images/add_photo_icon_drk.svg"} smallImg={"images/add_circle_wht.svg"}>
                    <div className="add-session-block-body-ctx">
                        <div className="add-session-block-body-ctx-holder">
                            <ul>
                                <li>Select the training material type below for your session. Then select the video/image/document by clicking the <i>+Add</i> buttons.</li>
                            </ul>
                        </div>
                        <button style={{ lineBreak: "30px" }}>Add Material</button>
                    </div>
                </AddSessionField>
                <AddSessionField header={"STEP 3"} subHeader={"SHARE SESSION"} bigImg={"images/document_icon_drk.svg"} smallImg={"images/share_icon_wht.svg"}>
                    <div className="add-session-block-body-ctx">
                        <div className="add-session-block-body-ctx-holder">
                            <ul>
                                <li>Share your training session with friends, team mates or teams.</li>
                            </ul>
                        </div>
                        <div className="add-session-block-body-ctx-holder">
                            <div className="add-session-block-body-ctx-wts" onClick={() => this.openTag("F")}>
                                <img src={"images/who_sees_friends.svg"} />
                                <span>Friends</span>
                            </div>
                            <div className="add-session-block-body-ctx-wts" onClick={() => this.openTag("Q")}>
                                <img src={"images/facebook-group.svg"} style={{ background: "#58CC66", borderRadius: "100px", padding: "2px" }} />
                                <span>Teams</span>
                            </div>
                            <div className="add-session-block-body-ctx-wts" onClick={() => this.openTag("T")}>
                                <img src={"images/who_sees_game.svg"} />
                                <span>Groups</span>
                            </div>
                        </div>
                    </div>
                </AddSessionField>
                <AddSessionField header={"STEP 4"} subHeader={"COMPLETE SESSION"} bigImg={"images/document_icon_drk.svg"} smallImg={"images/tick_circle_wht.svg"}>
                    <div className="add-session-block-body-ctx">
                        <div className="add-session-block-body-ctx-holder">
                            <ul>
                                <li>Select the training material type below for your session. Then select the video/image/document by clicking the <i>+Add</i> buttons.</li>
                            </ul>
                        </div>
                        <button style={{ lineBreak: "30px" }}>Complete Session</button>
                    </div>
                </AddSessionField>
                {this.state.isTaggingAudience && <WhoToSeePicker filters={["F", "Q", "T"]} active={this.state.audienceKey} isOpen={this.state.isTaggingAudience} onClose={(arr) => this.onClose(arr)} />}
            </div>
        )
    }
}

const AddSessionField = (props) => {
    const { header, subHeader, children, bigImg, smallImg } = props
    return (
        <div className="add-session-block-ctx">
            <div className="add-session-block-head">
                <div>
                    <img src={smallImg} />
                    <img src={bigImg} />
                </div>
                <span>{header}</span>
            </div>
            <div className="add-session-block-sub-head">{subHeader}</div>
            <div className="add-session-block-body">{children}</div>
        </div>
    )
}

class CategorieItem extends Component {
    constructor(props) {
        super(props);

    }

    render = () => {
        const { item, selection } = this.props
        return (
            <div className="cat-item" tabIndex={0}>
                <div data-label="">
                    <span className="open"></span>
                    <span>{item.name}</span>
                </div>
                <div data-list>
                    {
                        FakeData.listify(item.value).map((t, i) => {
                            return (
                                <div key={i} onClick={() => this.props.onSelectedItem(item.name + "^" + t)}>
                                    <input id={t + i} checked={FakeData.inArray(item.name + "^" + t, selection) ? true : false} name="checkbox" type="checkbox" /> <label >{t}</label>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}

export class TRNoticeModal extends Component {
    state = {
        tabs: [
            "New training sessions",
            "New training material",
            "Suggestions"
        ],
        active: "New training sessions",
        activeFilterTab: "All",

    }

    getItems = (key) => {
        const { newMaterial, suggestions, sessions } = this.props;
        const { active } = this.state;
        const _active = key ? key : active;
        if (_active === "New training sessions") {
            const list = FakeData.listify(newMaterial).filter((item) => {
                return item.type === "session";
            });

            return list;
        } else if (_active === "New training material") {
            const list = FakeData.listify(newMaterial).filter((item) => {
                return item.type === "material";
            });

            return list;
        } else {
            const list = FakeData.listify(suggestions).filter((item) => {
                return item.type === "material";
            });

            return list;
        }
    }

    render = () => {
        const { isOpen, onClose, sessions } = this.props;
        const { tabs, active, activeFilterTab } = this.state;
        const _items = this.getItems();
        return (
            <Modal isOpen={isOpen} onClose={onClose}>
                <div className="tr-notice-modal" style={{ width: "50vw", minHeight: "30vw", background: "#fff" }}>
                    <div className="tr-notice-modal-header">
                        {
                            tabs.map((item, i) => {
                                return (
                                    <div key={i} className={active === item ? "active" : ""} onClick={() => {
                                        this.setState({ active: item });
                                    }}>
                                        {item}
                                        {this.getItems(item).length > 0 && <span>{FakeData.shortDigit(this.getItems(item).length).data}</span>}
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="tr-notice-modal-body">
                        {active !== "New training sessions" &&
                            <div className="tr-notice-modal-body-head">
                                <span className={activeFilterTab == "All" ? "active" : ""} onClick={() => {
                                    this.setState({ activeFilterTab: "All" });
                                }}>All</span>
                                <span className={activeFilterTab == "Videos" ? "active" : ""} onClick={() => {
                                    this.setState({ activeFilterTab: "Videos" });
                                }}>Videos</span>
                                <span className={activeFilterTab == "Images" ? "active" : ""} onClick={() => {
                                    this.setState({ activeFilterTab: "Images" });
                                }}>Images</span>
                                <span className={activeFilterTab == "Documents" ? "active" : ""} onClick={() => {
                                    this.setState({ activeFilterTab: "Documents" });
                                }}>Documents</span>
                            </div>
                        }
                        <div className="tr-notice-modal-body-filter">
                            <select />
                            <input placeholder={active !== "New training sessions" ? "Search for friend, team or group" : "Search for friend"} />
                            <select />
                        </div>
                        <div className="tr-notice-modal-body-ctx">
                            {
                                _items.map((item, i) => {
                                    return (
                                        <TRNoticeItem toId={this.props.toId} toType={this.props.toType} sessions={sessions} item={item} key={i + item.id + item.date} type={active === "New training sessions" ? "session" : "material"} action={active !== "Suggestions" ? "added" : "suggested"} />
                                    )
                                })
                            }
                            {(active === "New training sessions" && _items.length === 0) &&
                                <EmptyState isShown={true} icon={"notifications"} text="Nothing at the moment!" />
                            }
                            {(active === "New training material" && _items.length === 0) &&
                                <EmptyState isShown={true} icon={"notifications"} text="Nothing at the moment!" />
                            }
                            {(active === "Suggestions" && _items.length === 0) &&
                                <EmptyState isShown={true} icon={"notifications"} text="Nothing at the moment!" />
                            }
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

class TRNoticeItem extends Component {
    state = {
        isAdding: false,
        rename: "",
        session: ""
    }

    addSession = () => {
        const _that = this;
        const { type, action, item, sessions, toId, toType } = this.props; // toId={this.props.toId} toType={this.props.toType}
        const { isAdding, rename, session } = this.state;
        item.content.rename = rename;
        const data = {
            user: {
                id: toId,
                type: toType
            },
            session: item.content,
            id: item.id
        }

        FakeData.post("/acceptSuggestedSession.php?auth0", data, {
            success(res) {
                if (res.status) {
                    FakeData.alert("Session was added!")
                } else {
                    FakeData.alert("Couldn't add session!")
                }
            },
            error(er) {
                FakeData.alert("Couldn't add session!")
            }
        }, true, "", () => { })
    }

    addFile = () => {
        const _that = this;
        const { type, action, item, sessions } = this.props;
        const { isAdding, rename, session } = this.state;
        if (session === "") {
            FakeData.alert("Please select a session");
            return;
        }
        const s = sessions.filter((item) => {
            return item.id === session;
        })[0]
        const data = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            session: { id: session, name: s['name'] },
            file: item.content,
            from: item.from,
            item: { rename: rename },
            isNew: action === "suggested" ? false : true,
            id: item.id
        }

        FakeData.post("/acceptSuggestion.php?auth0", data, {
            success(res) {
                if (res.status) {
                    FakeData.alert("Material was added to " + s['name'] + "!")
                } else {
                    FakeData.alert("Couldn't add material!")
                }
            },
            error(er) {
                FakeData.alert("Couldn't add material!")
            }
        }, true, "", () => { })
    }

    render = () => {
        const { type, action, item, sessions } = this.props;
        const { isAdding, rename, session } = this.state;

        return (
            <div className="tr-notice-item">
                <div className="tr-notice-item-head">
                    <img src={item.from.image} className="tr-notice-item-head-up" />
                    <div className="tr-notice-item-head-content">
                        <span className="tr-notice-item-head-content-title"><strong>{item.from.name}</strong> {action} {type === "session" ? "a" : item.content.type === "image" ? "an" : "a"} {type === "session" ? "training session" : item.content.type} : <strong>{type === "session" ? item.content.name : item.content.title}</strong> </span>
                        {type !== "session" && <span className="tr-notice-item-head-content-sport">Sport : <strong>{item.content.sport.name}</strong> | Category : <strong>{FakeData.listify(item.content.tags).map((item, i) => {
                            if (i > 3) {
                                return null;
                            }

                            return <span key={i}>{item}{i == 3 ? "..." : ", "}</span>
                        })}</strong></span>}
                        <span className="tr-notice-item-head-content-time">{window.moment(item.date).calendar()}</span>
                    </div>
                    <div className="tr-notice-item-head-action" data-button>
                        <span>Add</span>
                        <div>
                            <a className="add" onClick={() => this.setState({ isAdding: (isAdding) ? false : true })}></a>
                        </div>
                    </div>
                    {type !== "session" && <img src={item.content.type === "image" ? item.content.file.url : item.content.type === "video" ? "images/video.icon.svg" : "images/document_icon.svg"} className="tr-notice-item-head-cp" />}
                </div>
                {isAdding &&
                    <div className="tr-notice-item-body">
                        <div className="input-field"><span>Rename</span><input value={rename} className="normal-input" onChange={(e) => {
                            this.setState({ rename: e.target.value });
                        }} /></div>
                        {type !== "session" &&
                            <div className="input-field">
                                <span>Select session</span>
                                <select value={session} className="normal-input" onChange={(e) => {
                                    this.setState({ session: e.target.value });
                                }}>
                                    <option value={""}>Select session</option>
                                    {
                                        sessions.map((_item, i) => {
                                            return (
                                                <option value={_item.id}>{_item.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        }
                        <div className="action" onClick={() => {
                            if (type !== "session") {
                                this.addFile()
                            } else {
                                this.addSession()
                            }
                        }}>Add</div>
                    </div>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Training.jsx